<template>
   <div>
      <v-container>
         <v-row class="pt-3">
            <v-toolbar dense color="primary white--text" bottom class="mx-2">
               <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                  <v-icon left color="white">mdi-email-outline</v-icon>
                  Inbox
               </v-toolbar-title>
               <v-icon color="white" v-else>mdi-email-outline</v-icon>
            </v-toolbar>
         </v-row>
         <v-row class="pt-3">
            <v-col cols="12" md="4" class="px-1 mt-2">
               <v-toolbar v-if="$vuetify.breakpoint.mdAndUp" color="primary white--text" bottom>
                  <v-toolbar-title>Messages</v-toolbar-title>
               </v-toolbar>
               <v-card outlined flat height="65vh" class="overflow-y-auto">
                  <v-list>
                     <v-list-item-group
                        mandatory
                        active-class="messageselect"
                        v-model="$globalstore.user.msgindex"
                     >
                        <v-list-item
                           v-for="(msg, i) in messages"
                           :key="i"
                           :ripple="false"
                           @click="showFullBody(i)"
                        >
                           <v-list-item-content>
                              <v-row no-gutters class="pl-1 mb-0">
                                 <v-col cols="8" md="8" align-self="start">
                                    {{ msg.msg_sendername }}
                                 </v-col>
                                 <v-col cols="4" md="4">
                                    <p class="text-right datetext">
                                       {{ fmtDate(msg.msg_date) }}
                                    </p>
                                 </v-col>
                              </v-row>
                              <v-row no-gutters class="pl-1">
                                 {{ msg.msg_subject }}
                              </v-row>
                           </v-list-item-content>
                        </v-list-item>
                     </v-list-item-group>
                  </v-list>
               </v-card>
            </v-col>
            <v-col cols="12" md="8" class="px-1 mt-2">
               <v-card
                  outlined
                  flat
                  height="75vh"
                  class="overflow-y-auto"
                  v-if="$vuetify.breakpoint.mdAndUp"
               >
                  <v-sheet>
                     <v-card
                        v-if="selectedmessage"
                        class="px-2"
                        outlined
                        :color="$globalstore.secondary_titleclass"
                     >
                        <v-card-title class="pt-2 pb-0">
                           <v-row>
                              <v-col cols="8" md="8">
                                 {{ message_sender }}
                              </v-col>
                              <v-col cols="4" md="4">
                                 <p class="text-right">
                                    {{ message_date }}
                                 </p></v-col
                              >
                           </v-row>
                        </v-card-title>
                     </v-card>
                     <v-card tile flat v-if="selectedmessage" class="mt-1">
                        <v-card-text>
                           <div class="text-subtitle-1 font-weight-medium">
                              Subject
                           </div>
                           <span class="text-body-1">{{ message_subject }}</span>
                        </v-card-text>
                     </v-card>
                     <v-card flat class="px-3 mt-2 overflow-y-auto">
                        <editor-content :editor="editor" />
                        <!-- <span class="font-weight-thin">{{ message_body }}</span> -->
                     </v-card>
                  </v-sheet>
               </v-card>
            </v-col>
         </v-row>
      </v-container>
   </div>
</template>

<script>
   import ViewMessage from "@/components/ViewMessage.vue";
   import {Editor, EditorContent} from "@tiptap/vue-2";
   import StarterKit from "@tiptap/starter-kit";
   import TextStyle from "@tiptap/extension-text-style";
   import {Color} from "@tiptap/extension-color";
   import TextAlign from "@tiptap/extension-text-align";
   import Table from "@tiptap/extension-table";
   import TableRow from "@tiptap/extension-table-row";
   import TableCell from "@tiptap/extension-table-cell";
   import TableHeader from "@tiptap/extension-table-header";
   import UnderLine from "@tiptap/extension-underline";

   export default {
      inject: ["ShowMessage", "ServerDateTime"],

      components: {ViewMessage, EditorContent},

      data() {
         return {
            messages: [],
            selectedmessage: null,
            editor: null,
            todayDate: this.$globalstore.currentDateISOString().substr(0, 10),
         };
      },

      computed: {
         message_subject() {
            return this.selectedmessage ? this.selectedmessage.msg_subject : "";
         },

         message_body() {
            return this.selectedmessage ? this.selectedmessage.msg_body : "";
         },

         message_sender() {
            return this.selectedmessage ? this.selectedmessage.msg_sendername : "";
         },

         message_date() {
            return this.selectedmessage ? this.fmtDate(this.selectedmessage.msg_date) : "";
         },
      },

      methods: {
         fmtDate(date) {
            const d1 = new Date(date);
            const d2 = new Date();

            let d1str = this.$globalstore.dateToISOString(d1).substr(0, 10);
            let d2str = this.$globalstore.currentDateISOString().substr(0, 10);

            if (d1str === d2str) {
               return (
                  d1
                     .getHours()
                     .toString()
                     .padStart(2, "0") +
                  ":" +
                  d1
                     .getMinutes()
                     .toString()
                     .padStart(2, "0")
               );
            } else {
               if (d1.getFullYear() === d2.getFullYear()) {
                  let month = new Intl.DateTimeFormat("en-US", {
                     month: "short",
                  }).format(d1);
                  let day = d1.getDate();
                  return month.toString() + " " + day.toString();
               } else {
                  const [year, day] = [d1.getFullYear(), d1.getDate()];
                  let month = new Intl.DateTimeFormat("en-US", {
                     month: "short",
                  }).format(d1);

                  return year.toString() + " " + month.toString() + " " + day.toString();
               }
            }
         },

         showFullBody(index) {
            this.$globalstore.user.msgindex = index;
            if (this.$vuetify.breakpoint.mobile) {
               this.$router.push({
                  name: "ViewMessage",
                  params: this.messages[this.$globalstore.user.msgindex],
               });
            } else {
               this.selectedmessage = this.messages[this.$globalstore.user.msgindex];
               this.editor.commands.setContent(this.selectedmessage.msg_body);
            }
         },

         async loadUserMessages() {
            await this.$http({
               url: "/common/getusermessages.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.messages = response.data.usermessages;
                  }
               }
            });
         },
      },

      mounted() {
         this.loadUserMessages();

         this.editor = new Editor({
            editable: false,
            content: "",
            extensions: [
               StarterKit,
               TextStyle,
               Color,
               TextAlign.configure({
                  types: ["heading", "paragraph"],
               }),
               Table.configure({
                  resizable: true,
               }),
               TableRow,
               TableCell,
               TableHeader,
               UnderLine,
            ],
         });

         // if (this.$vuetify.breakpoint.mdAndUp) {
         //    if (this.$globalstore.user.msgindex) {
         //       this.showFullBody(this.$globalstore.user.msgindex);
         //    } else {
         //       this.showFullBody(0);
         //    }
         // }
      },
   };
</script>

<style scoped>
   .ProseMirror p {
      line-height: 1.2em;
      margin-bottom: 0.3em;
   }
   .messageselect {
      background: #e57373 !important;
      color: white !important;
   }
   .datetext {
      font-size: 0.85em;
   }
</style>
